document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".hp-redeem-btn");
  if (!btn) return;

  const productId = btn.dataset.productId;              // ✅ para backend
  const variantId = btn.dataset.variantId;              // ✅ para /cart/add.js
  const points = Number(btn.dataset.points);            // ✅ obligatorio
  const customerId = window.HOOSH_CUSTOMER_ID;

  if (!customerId) return alert("Debes iniciar sesión");
  if (!productId || !variantId) return alert("Producto inválido (faltan IDs)");
  if (!points || points <= 0) return alert("Puntos inválidos");

  const redeemId = `ui_${productId}_${Date.now()}`;

  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = "Canjeando…";

  try {
    // 1) Canje en backend (descuenta + crea discount)
    const res = await fetch(
      "https://ngva16rejf.execute-api.us-east-2.amazonaws.com/loyalty/redeem/free-product",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customer_id: customerId,
          product_id: productId,     // ✅ PRODUCT ID
          redeem_id: redeemId,
          points: points
        })
      }
    );

    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.discount_code) {
      console.error("Redeem backend error:", res.status, data);
      throw new Error(data.error || "redeem_failed");
    }

    // 2) Agrega el producto al carrito (Shopify necesita VARIANT ID)
    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    const addData = await addRes.json().catch(() => ({}));
    if (!addRes.ok) {
      console.error("Cart add error:", addRes.status, addData);
      throw new Error(addData.description || "cart_add_failed");
    }

    // 3) Checkout con discount
    window.location.href = `/checkout?discount=${encodeURIComponent(data.discount_code)}`;
  } catch (err) {
    console.error(err);
    alert("No se pudo completar el canje");
    btn.disabled = false;
    btn.textContent = originalText;
  }
});
